import { web3 } from '@project-serum/anchor';

export const METADATA_PROGRAM_PUBKEY = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');

export const METADATA_PREFIX = 'metadata';

export const EDITION_PREFIX = 'edition';
